<div class="container">
  <div class="row product">
    <div class="col-md-6">
      <img [src]="product?.image" alt="" />
      <!-- <div class="gallery">
        <img *ngFor="let item of product.gallery; index as i" (click)="chooseImage(item.image , i )"
        src="{{item.image}}" alt="">
      </div> -->
    </div>
    <div class="col-md-4">
      <h2>
        {{ product?.name }}
      </h2>
      <h3>
        {{ product?.details }}
      </h3>
      <!-- <h2>
        EGP {{product?.price}}
      </h2> -->
      <h4>
        {{ "the price reflects selected options" | translate }}
      </h4>
      <!-- <span>
        40695882
      </span> -->
      <p>
        {{ product?.description }}
      </p>
      <h2>
        {{ "size" | translate }}
      </h2>
      <h3>
        {{ product?.size }}
      </h3>
    </div>
  </div>
</div>
<ngx-json-ld [json]="jsonLD"></ngx-json-ld>
<app-interested-form [product_id]="product?.id"></app-interested-form>
